import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation, Link } from "react-router-dom";
import api from "../../../services/api";
import { useAuth } from "../../../contexts/AuthContext";
import { Button, Breadcrumb, StatusBadge } from "../../../components/ui";
import { usePageHeader } from "../../../contexts/PageHeaderContext";
import "./Corrections.css";
const money = (n) =>
  new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 2 }).format(
    Number(n) || 0,
  ) + " ₽";
export default function CorrectionDetail() {
  const { user } = useAuth();
  const { correctionId } = useParams(),
    navigate = useNavigate(),
    location = useLocation();
  const [data, setData] = useState(null),
    [error, setError] = useState("");
  usePageHeader({ title: null, hideTopHeader: true }, []);
  useEffect(() => {
    let active = true;
    api
      .get(`/company/corrections/${correctionId}`)
      .then((r) => {
        if (active) setData(r.data);
      })
      .catch((e) =>
        setError(
          e.response?.data?.error || "Не удалось загрузить корректировку",
        ),
      );
    return () => {
      active = false;
    };
  }, [correctionId]);
  if (!data) return <div className="company-page">{error || "Загрузка…"}</div>;
  const p = data.custom_data.correction;
  const received = new Map();
  for (const e of data.acted || [])
    received.set(
      [e.employee, e.team, e.sub_team || ""].join("|"),
      Number(e.amount) || 0,
    );
  return (
    <div className="company-page cw-page">
      <Breadcrumb
        items={[
          { label: "Бюджеты", to: "/company/budgets" },
          {
            label: "Корректировки",
            to: `/company/budgets/${data.object_stage_id}`,
          },
          { label: p.name },
        ]}
      />
      <header className="cw-header">
        <div>
          <h1>
            {p.name} <StatusBadge>{data.status}</StatusBadge>
          </h1>
          <p>{data.id}</p>
        </div>
        {user?.permissions?.["stages.update"] && (
          <Button
            variant="primary"
            onClick={() =>
              navigate(`/company/corrections/${correctionId}/edit`)
            }
          >
            Изменить распределение
          </Button>
        )}
      </header>
      {location.state?.created && (
        <div className="cw-plan-banner" role="status">
          Корректировка создана · доходы пересчитаны
        </div>
      )}
      <div className="cw-stats">
        {[
          ["Без НДС", p.amount_without_vat],
          ["С НДС", p.amount_with_vat],
          ["Производство", p.production_amount],
          ["Обслуживание", p.service_amount],
        ].map(([label, amount]) => (
          <div key={label}>
            <span>{label}</span>
            <strong>{money(amount)}</strong>
          </div>
        ))}
      </div>
      {p.description && (
        <section className="cw-card">
          <h2>Что корректируем</h2>
          <p style={{ whiteSpace: "pre-wrap" }}>{p.description}</p>
        </section>
      )}
      <div className="cw-plan-banner">
        Индивидуальное распределение · суммы заданы вручную ·{" "}
        <Link
          to={`/admin/budget/custom-team-percentages?stage_id=${encodeURIComponent(data.id)}&contract_id=${encodeURIComponent(data.contract_id)}`}
        >
          Уникальные проценты сотрудников
        </Link>
      </div>
      <section className="cw-card">
        <div className="cw-header-actions">
          <h2>Распределение бюджета</h2>
          <Button
            variant="secondary"
            onClick={() => navigate(`/stage/${data.public_id}/report-preview`)}
          >
            Отчёт и PDF
          </Button>
        </div>
        <div className="cw-table-scroll">
          <table>
            <thead>
              <tr>
                <th>Подразделение</th>
                <th>Исполнитель</th>
                <th>По бюджету</th>
                <th>% распределения</th>
                <th>Заактировано</th>
              </tr>
            </thead>
            <tbody>
              {p.departments.flatMap((d) =>
                d.employees
                  .filter((e) => e.enabled && Number(e.amount) > 0)
                  .map((e) => (
                    <tr
                      key={d.id + e.employee_id + e.team + (e.sub_team || "")}
                    >
                      <td>
                        {d.name}
                        <small>
                          {[e.team, e.sub_team].filter(Boolean).join(" / ")}
                        </small>
                      </td>
                      <td>{e.employee_name}</td>
                      <td>{money(e.amount)}</td>
                      <td>
                        {((e.amount / p.amount_without_vat) * 100).toFixed(4)}%
                      </td>
                      <td>
                        {money(
                          received.get(
                            [e.employee_name, e.team, e.sub_team || ""].join(
                              "|",
                            ),
                          ),
                        )}
                      </td>
                    </tr>
                  )),
              )}
              {p.services
                .filter((s) => !s.removed)
                .map((s) => (
                  <tr key={s.key}>
                    <td colSpan={2}>{s.name}</td>
                    <td>{money(s.amount)}</td>
                    <td>{Number(s.percentage).toFixed(4)}%</td>
                    <td>—</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
